import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.relatedTablesDefinition],
        config: {
            headerName: getLocalizedString("sourceTable"),
            field: "fromTable",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.relatedTablesDefinition],
        config: {
            headerName: getLocalizedString("sourceField"),
            field: "fromField",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.relatedTablesDefinition],
        config: {
            headerName: getLocalizedString("sourceFieldName"),
            field: "fromFieldName",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.relatedTablesDefinition],
        config: {
            headerName: getLocalizedString("destinationTable"),
            field: "toTable",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.relatedTablesDefinition],
        config: {
            headerName: getLocalizedString("destinationCodeField"),
            field: "toField",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.relatedTablesDefinition],
        config: {
            headerName: getLocalizedString("destinationDescriptionField"),
            field: "toFieldDescription",
            filter: "agSetColumnFilter",
        }
    },
]